<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Type</mat-label>
                    <mat-select data-select-type formControlName="type" required panelClass="testClass">
                        <mat-option data-select-listing-type-option value="Text">Texte</mat-option>
                        <mat-option data-select-listing-type-option value="Number">Nombre</mat-option>
                        <mat-option data-select-listing-type-option value="Date">Date</mat-option>
                        <mat-option data-select-listing-type-option value="Boolean">Booléen</mat-option>
                    </mat-select>
                    @if (formGroupErrors?.type?.required && (formGroup.controls['type']?.dirty || formGroup.controls['type'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Type' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Type" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom du groupe</mat-label>
                    <input matInput data-input-groupName type="text" formControlName="groupName" autocomplete="off" required />
                    @if (formGroupErrors?.groupName?.required && (formGroup.controls['groupName']?.dirty || formGroup.controls['groupName'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom du groupe' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom du groupe" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                {{ formGroup.get('type').value }}

                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur par défaut</mat-label>
                    @if (formGroup.get('type').value === 'Number') {
                        <input matInput data-input-defaultValue type="number" formControlName="defaultValue" autocomplete="off" required />
                    }
                    @if (formGroup.get('type').value === 'Date') {
                        <input matInput data-input-defaultValue type="date" formControlName="defaultValue" autocomplete="off" required />
                    }
                    @if (formGroup.get('type').value === 'Boolean') {
                        <mat-select data-select-type formControlName="defaultValue" required>
                            <mat-option value="false">Faux</mat-option>
                            <mat-option value="true">Vrai</mat-option>
                        </mat-select>
                    } @else {
                        <input matInput data-input-defaultValue type="text" formControlName="defaultValue" autocomplete="off" required />
                    }
                    @if (formGroupErrors?.defaultValue?.required && (formGroup.controls['defaultValue']?.dirty || formGroup.controls['defaultValue'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Valeur par défaut' est obligatoire</mat-error>
                    }
                </mat-form-field>

                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Valeur par défaut" matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
